$(document).ready(() => {

    $('.yotpo-bottomline a').replaceWith(function(){
        return $('<div/>', {
            html: this.innerHTML
        })
    });

        // Social Proof
        $('.logo-slider').slick({
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                                breakpoint: 1024,
                                settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 1,
                                        infinite: true,
                                        dots: false,
                                },
                        },
                        {
                                breakpoint: 767,
                                settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                        peed: 1000,
                                        autoplay: true,
                                        autoplaySpeed: 4000,
                                        infinite: true,
                                        dots: false,
                                },
                        },
                        {
                                breakpoint: 600,
                                settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        infinite: true,
                                        dots: false,
                                        autoplay: true,
                                        autoplaySpeed: 4000,
                                },
                        },

                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                ],
        });

        // Slick Slider
        $('.testimonial-slider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                centerMode: true,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
        });

        $('.testimonial-slider-pages').slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
        });


        // Wheel Click Modal
        $('button.btn-prime').on('mousedown', (e) => {
                if (e.which === 2) {
                        e.preventDefault();
                        e.stopPropagation();
                        $(e.currentTarget).trigger('click');
                }
        });

        // Product Page Info Tab Section
        $('#toggle span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#toggle1 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#toggle2 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#toggle3 span').on('click', function () {
                $(this).toggleClass('open');
        });

        $('#Shipping_toggle1 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#Shipping_toggle2 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#Shipping_toggle3 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#Shipping_toggle4 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#Shipping_toggle5 span').on('click', function () {
                $(this).toggleClass('open');
        });
        $('#Size_toggle5 span').on('click', function () {
                $(this).toggleClass('open');
        });

        // Workout "Read More" Content
        $('.nav-toggle').click(function () {
                var collapse_content_selector = $(this).attr('href');
                var toggle_switch = $(this);
                $(collapse_content_selector).toggle(function () {
                        if ($(this).css('display') == 'none') {
                                toggle_switch.html('');
                        } else {
                                toggle_switch.html('');
                        }
                });
        });



        $('.heading-toggle').click(function () {
                var collapse_content_selector = $(this).attr('href');
                var toggle_switch = $(this);
                $(collapse_content_selector).toggle(function () {
                        if ($(this).css('display') == 'none') {
                                toggle_switch.addClass('rrrr');
                        } else {
                                toggle_switch.removeClass('rrrr');
                        }
                });
        });
});
